import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getPlafonPerobatan = createAsyncThunk(
    "plafonPerobatan/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getSetupPlafonPerobatan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertPlafonPerobatan = createAsyncThunk(
    "plafonPerobatan/insert",
    async ({namaPlafonPerobatan, golonganID, tipeKaryawanID, nominalSatuTahun}, thunkAPI) => {
        let formData = new FormData();
        formData.append("namaPlafonPerobatan", namaPlafonPerobatan);
        formData.append("golonganID", golonganID);
        formData.append("tipeKaryawanID", tipeKaryawanID);
        formData.append("nominalSatuTahun", nominalSatuTahun);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertSetupPlafonPerobatan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updatePlafonPerobatan = createAsyncThunk(
    "plafonPerobatan/update",
    async ({
               setupPlafonPerobatanID,
               namaPlafonPerobatan,
               golonganID,
               tipeKaryawanID,
               nominalSatuTahun,
               status
           }, thunkAPI) => {
        let formData = new FormData();
        formData.append("setupPlafonPerobatanID", setupPlafonPerobatanID);
        formData.append("namaPlafonPerobatan", namaPlafonPerobatan);
        formData.append("golonganID", golonganID);
        formData.append("tipeKaryawanID", tipeKaryawanID);
        formData.append("nominalSatuTahun", nominalSatuTahun);
        formData.append("status", status);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateSetupPlafonPerobatan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

const initialState = {
    message: "",
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const plafonPerobatanSlice = createSlice({
    name: "plafonPerobatan",
    initialState,
    reducers: {},
    extraReducers: {
        [getPlafonPerobatan.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getPlafonPerobatan.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getPlafonPerobatan.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertPlafonPerobatan.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertPlafonPerobatan.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertPlafonPerobatan.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updatePlafonPerobatan.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updatePlafonPerobatan.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updatePlafonPerobatan.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const plafonPerobatanSelector = (state) => state.plafonPerobatan;
